import { render, staticRenderFns } from "./ClinicalAssistantLauncher.vue?vue&type=template&id=08c5f297&scoped=true"
import script from "./ClinicalAssistantLauncher.vue?vue&type=script&lang=js"
export * from "./ClinicalAssistantLauncher.vue?vue&type=script&lang=js"
import style0 from "./ClinicalAssistantLauncher.vue?vue&type=style&index=0&id=08c5f297&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c5f297",
  null
  
)

export default component.exports